import { render, staticRenderFns } from "./CreateAccountFlow.vue?vue&type=template&id=c8a56e04&scoped=true&"
import script from "./CreateAccountFlow.vue?vue&type=script&lang=js&"
export * from "./CreateAccountFlow.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountFlow.vue?vue&type=style&index=0&id=c8a56e04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a56e04",
  null
  
)

export default component.exports